// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerImage_banner__3BgnM"};